/**
 * Payment Gateways
 */
const paymentGateways = {
    nets: {
        TEST: {
            purpose: "test",
        },
        PRODUCTION: {
            purpose: "production",
        },
    },
};
/**
 * list of enviroments
 */
const enviroments = [
    {
        type: "development",
        hostname: "192.168.8.116",
        domain: "http://192.168.8.116:8080/", // Allow network device testing - Must be changed to development computer IP
        imageServer: "https://staging.bookbyen.dk/",
        api: "https://apiv3-staging.bookbyen.dk/1.0",
        apiLegacy: "https://staging.bookbyen.dk/web/api",
        identityServer: "https://auth-staging.bookbyen.dk",
        debug: false,
        enableDummyApi: false,
        enableDevBar: false,
        enableLog: true,
        storageVersion: "1.0.1",
        payment: {
            enabled: true,
            gateway: paymentGateways.nets.TEST,
        },
    },
    {
        type: "development",
        hostname: "localhost",
        domain: "http://localhost:8080",
        imageServer: "https://staging.bookbyen.dk/",
        api: "https://apiv3-staging.bookbyen.dk/1.0",
        apiLegacy: "https://staging.bookbyen.dk/web/api",
        identityServer: "https://auth-staging.bookbyen.dk",
        debug: false,
        enableDummyApi: false,
        enableDevBar: false,
        enableLog: true,
        storageVersion: "1.0.1",
        payment: {
            enabled: true,
            gateway: paymentGateways.nets.TEST,
        },
    },
    {
        type: "testing",
        hostname: "testing.bookbyen.dk",
        domain: "https://staging.bookbyen.dk",
        api: "https://apiv3-staging.bookbyen.dk/1.0",
        apiLegacy: "https://staging.bookbyen.dk/web/api",
        identityServer: "https://auth-staging.bookbyen.dk",
        debug: false,
        enableDummyApi: false,
        enableDevBar: false,
        storageVersion: "1.0.0",
        payment: {
            enabled: true,
            gateway: paymentGateways.nets.TEST,
        },
        enableLog: true,
    },
    {
        type: "staging",
        hostname: "staging.bookbyen.dk",
        domain: "https://staging.bookbyen.dk",
        api: "https://apiv3-staging.bookbyen.dk/1.0",
        apiLegacy: "https://staging.bookbyen.dk/web/api",
        identityServer: "https://auth-staging.bookbyen.dk",
        debug: false,
        enableDummyApi: false,
        enableDevBar: false,
        storageVersion: "1.0.0",
        payment: {
            enabled: true,
            gateway: paymentGateways.nets.TEST,
        },
        enableLog: true,
    },
    {
        type: "staging",
        hostname: "staging.u-bahn.dk",
        domain: "https://staging.u-bahn.dk",
        api: "https://apiv3-staging.u-bahn.dk/1.0",
        apiLegacy: "https://staging.u-bahn.dk/web/api",
        identityServer: "https://auth-staging.u-bahn.dk",
        debug: false,
        enableDummyApi: false,
        enableDevBar: false,
        storageVersion: "1.0.0",
        payment: {
            enabled: true,
            gateway: paymentGateways.nets.TEST,
        },
        enableLog: true,
    },
    {
        type: "production",
        hostname: "bookbyen.dk",
        domain: "https://bookbyen.dk",
        api: "https://apiv3.bookbyen.dk/1.0",
        apiLegacy: "https://bookbyen.dk/web/api",
        identityServer: "https://auth.bookbyen.dk",
        debug: false,
        enableDummyApi: false,
        enableDevBar: false,
        storageVersion: "1.0.0", // carefull... if version is raised localstorage will be cleared - users will loose ongoing checkout flows
        payment: {
            enabled: true,
            gateway: paymentGateways.nets.PRODUCTION,
        },
        enableLog: false,
    },
];

const Environment = {
    /**
     *
     * Get enviroment
     * hook current Enviroment using window.location.hostname
     * @return currentEnv
     */
    get: () => {
        const hostname = window.location.hostname;

        let currentEnv;
        enviroments.forEach((enviroment) => {
            if (enviroment.hostname == hostname) {
                currentEnv = enviroment;
            }
        });
        return currentEnv;
    },
};

export default Environment;
